import { AttackErrorAttribute } from '@collector/sportsapi-client-legacy'

export const zones = new Map<number, AttackErrorAttribute>([
  [1, AttackErrorAttribute.Zone1],
  [2, AttackErrorAttribute.Zone2],
  [3, AttackErrorAttribute.Zone3],
  [4, AttackErrorAttribute.Zone4],
  [5, AttackErrorAttribute.Zone5],
  [6, AttackErrorAttribute.Zone6],
])
